module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/facebook-19136181fecd19cedb218b7c71234970.svg";